var _atomStore$get;import { getRoutes } from "./Routes";
import { settingsAtom, atomStore, userAtom } from "./V2/atoms";

export const routes =
getRoutes && getRoutes(atomStore.get(settingsAtom), (_atomStore$get = atomStore.get(userAtom)) === null || _atomStore$get === void 0 ? void 0 : _atomStore$get._id);